module.exports = __webpack_public_path__ + "img/poweredby-black.d66e8ba0.png";